import { ActionItemRowTrigger } from "components/HomeActionItems/ActionItemRow";
import { TaxActionItemType } from "store/apis/actionItems";
import { useHistory } from "react-router-dom";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";

type Props = {
  item: TaxActionItemType;
};

export const StateComplianceActionItem = ({ item }: Props) => {
  const history = useHistory();
  const { isAdmin } = useRoleBasedView();
  const { uuid: groupId } = useCurrentGroupContext();

  const handleClick = () => {
    const { entity_id, state_id } = item;
    if (entity_id && state_id) {
      const path = isAdmin
        ? `/admin/crm/${groupId}/state-compliance/${state_id}?entity=${entity_id}&openMissingInfo=true`
        : `/tax/state-compliance/${state_id}?entity=${entity_id}&openMissingInfo=true`;
      history.push(path);
      return;
    }
    const entitySuffix = entity_id ? `?entity=${entity_id}` : "";
    const path = isAdmin
      ? `/admin/crm/${groupId}/state-compliance${entitySuffix}`
      : `/tax/state-compliance${entitySuffix}`;
    history.push(path);
  };

  return (
    <ActionItemRowTrigger
      customType={item.custom_type}
      itemCount={item.count}
      title={item.title}
      subtitle={item.subtitle}
      handleCardClick={handleClick}
    />
  );
};
